import React from 'react'
import { Image, Linking, StyleSheet } from 'react-native'

import { Pressable } from '@zet/design-system'
import { DEVICE_WIDTH } from '@zet/utils/Constants'

const TalkToExpert = () => {
  const handleOnPress = () => {
    Linking?.openURL(`tel:${'7417274072'}`)
  }
  return (
    <Pressable onPress={handleOnPress} style={styles.container}>
      <Image
        source={require('../../assets/images/talkWithSupport.webp')}
        style={styles.img}
        resizeMode="contain"
      />
    </Pressable>
  )
}

export default TalkToExpert

const styles = StyleSheet.create({
  container: {
    width: DEVICE_WIDTH,
    height: 130,
    alignItems: 'center',
  },
  img: {
    width: '92%',
    height: '100%',
    alignSelf: 'center',
  },
})
